import React, { useEffect, useState } from 'react';
import { MenuIcon, X } from 'lucide-react';
const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  const navLinks = [{
    name: 'Home',
    href: '#home'
  }, {
    name: 'Our Story',
    href: '#our-story'
  }, {
    name: 'Events',
    href: '#events'
  }, {
    name: 'Wedding Party',
    href: '#wedding-party'
  }, {
    name: 'Gallery',
    href: '#gallery'
  }, {
    name: 'RSVP',
    href: '#rsvp'
  }, {
    name: 'Gifts',
    href: '#gifts'
  }];
  return <nav className={`fixed w-full z-50 transition-all duration-300 ${scrolled ? 'bg-white bg-opacity-95 shadow-md py-2' : 'bg-transparent py-4'}`} data-id="element-101">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-102">
        <div className="flex justify-between items-center" data-id="element-103">
          <div className="flex items-center" data-id="element-104">
            <span className="font-serif text-gold text-xl" data-id="element-105">A&A</span>
          </div>
          <div className="hidden md:block" data-id="element-106">
            <div className="flex items-center space-x-8" data-id="element-107">
              {navLinks.map(link => <a key={link.name} href={link.href} className="font-sans text-sm font-medium text-gray-700 hover:text-gold transition-colors" data-id="element-108">
                  {link.name}
                </a>)}
            </div>
          </div>
          <div className="md:hidden" data-id="element-109">
            <button onClick={toggleMenu} className="text-gray-700 hover:text-gold focus:outline-none" data-id="element-110">
              {isOpen ? <X size={24} data-id="element-111" /> : <MenuIcon size={24} data-id="element-112" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {isOpen && <div className="md:hidden bg-white bg-opacity-95" data-id="element-113">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-114">
            {navLinks.map(link => <a key={link.name} href={link.href} className="block py-2 px-4 text-base font-medium text-gray-700 hover:text-gold" onClick={() => setIsOpen(false)} data-id="element-115">
                {link.name}
              </a>)}
          </div>
        </div>}
    </nav>;
};
export default Navbar;